<div class="theme-light">
  <router-outlet></router-outlet>
</div>

